import assignIn from 'lodash/assignIn'
import Http from './http'

import './form'
import './errors'

assignIn(Spark, Http)
